.container {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.label {
  font-weight: 600;
}

.button {
  opacity: 1;
  white-space: nowrap;
}

.buttonDisabled {
  opacity: 0.5;
}
